module.exports = __webpack_public_path__ + "img/fidelity.fa6e0981.svg";